export const isArray = <T>(predictable: unknown): predictable is T[] => {
  return Array.isArray(predictable);
};
